<template>
	<div v-if="!hideError" id="errorContainer" class="alert alert-danger text-center" :class="{ 'hide': hideError}" role="alert">
		<svgIcon iconHolderClass="icon-warning" iconId="icon-warning"/>
		{{ errorText }}
		<slot/>
	</div>
</template>

<script>
import svgIcon from './icon-svg';

export default {
	name: 'formError',
	introduction: 'Vujs error form component',
	components: {
		svgIcon
	},
	props: {
		hideError: {
			type: Boolean,
			default: true,
			note: 'Show and hide control'
		},
		errorCode: {
			type: [String, Number],
			default: '',
			note: 'Set error code to get translated text'
		},
		extraErrorData: {
			type: Object,
			default: () => ({}),
			note: 'Can be set some extra error date'
		}
	},
	computed: {
		errorText() {
			const text = this.$t(`error.form.${this.errorCode}`, this.extraErrorData);
			if (text.indexOf('error.form') === 0) {
				return `${this.$t('error.form.SERVER_ERROR')} ( code: ${this.errorCode} )`;
			}
			return text;
		}
	},
	watch: {
		hideError(val) {
			if (val) return;
			const container = document.getElementById('errorContainer');
			if (this.errorCode && container !== null) {
				container.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	},
};
</script>

<style lang="less" scoped>
	.alert {
		width: 100%;
	}
	@media (max-width: 740px) {
		.alert {
			margin-bottom: 0;
		}
	}
</style>
